export const userThemeTileTheme = {
  active: {
    bg: 'palette.primary.50:0.25',
  },
  inactive: {
    bg: 'palette.surface.4',
  },
  name: 'palette.tertiary.90',
};
